import { Col, notification, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

import TableHelper from '../../../helpers/TableHelper';
import apiAuth from '../../../services/apiAuth';
import { getColumns } from './columns';
import { Button, Table } from './styles';

export default function ListagemUsuarios({ cliente, handleAddNewUser }) {
  const [users, setUsers] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [filtersPage, setFiltersPage] = useState({});
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    position: ['bottomCenter'],
  });
  const handlerOnChangePagination = async cnpjResumido => {
    const keyFilter = ['name', 'razao_social', 'email', 'status'];

    try {
      setLoadingTable(true);
      let options = {
        page: pagination.current,
        size: pagination.pageSize,
      };

      if (filtersPage?.sorter?.order) {
        options = {
          ...TableHelper.definirOrdenacao(options, filtersPage.sorter),
        };
      }

      if (filtersPage?.filters && Object.keys(filtersPage.filters).length) {
        options = {
          ...TableHelper.definirFiltrosDinamicos(
            options,
            filtersPage.filters,
            keyFilter
          ),
        };
      }
      const response = await apiAuth.get('/users/shipper', {
        params: { ...options, cnpj_resumido: cnpjResumido },
      });

      setUsers(response.data.data);

      const {
        page: current,
        size: pageSize,
        total_elements: total,
      } = response.data;

      setPagination({
        ...pagination,
        current,
        pageSize,
        total,
      });
    } catch (err) {
      notification.error({
        message: 'Ops, não foi possível recuperar os usuários',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    } finally {
      setLoadingTable(false);
    }
  };
  const handleEditStatusUser = useCallback(
    async (idUsuario, status) => {
      const { cnpj_resumido } = cliente;

      try {
        setLoadingTable(true);

        await apiAuth.patch(`/users/shipper/${idUsuario}`, {
          status,
        });

        notification.success({
          message: 'Tudo certo',
          description: 'O status do usuário foi atualizado com sucesso.',
        });
      } catch (error) {
        notification.error({
          message: 'Ops, não foi possível atualizar o usuário',
          description:
            'Por favor, entre em contato com nosso suporte caso o problema persistir.',
        });
      } finally {
        handlerOnChangePagination(cnpj_resumido);
      }
    },
    [cliente]
  );

  const handleSendEmailUser = async ({ idUsuario, empresa }) => {
    try {
      await apiAuth.post(`/users/${idUsuario}/invite`, {
        razao_social: empresa,
      });

      notification.success({
        message: 'E-mail enviado para usuário',
        description:
          'Foi enviado um e-mail com o link para confirmação do cadastro do usuário',
      });
    } catch (error) {
      notification.error({
        message: 'Ops, não foi possível enviar o e-mail',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    }
  };

  // função que incia na construção do componente
  useEffect(() => {
    const { cnpj_resumido } = cliente;
    /**
     * Recupera todos os usuários da api-auth
     */
    async function getUsers() {
      if (!cnpj_resumido) return;
      handlerOnChangePagination(cnpj_resumido);
    }

    getUsers();
  }, [filtersPage, cliente]);

  const onChangeTable = (paginationParam, filters, sorter) => {
    setPagination({
      ...paginationParam,
    });
    setFiltersPage({
      ...filtersPage,
      filters,
      sorter,
    });
  };

  const columnsTable = getColumns(
    filtersPage,
    handleEditStatusUser,
    handleSendEmailUser
  );

  return (
    <>
      <Row justify="end" className="mb-20">
        <Button onClick={handleAddNewUser}>Novo usuário</Button>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            loading={loadingTable}
            dataSource={
              users.length &&
              users.map(user => ({
                ...user,
                key: user.idUsuario,
              }))
            }
            onChange={onChangeTable}
            columns={columnsTable}
            pagination={{
              ...pagination,
            }}
          />
        </Col>
      </Row>
    </>
  );
}

ListagemUsuarios.propTypes = {
  cliente: PropTypes.objectOf(PropTypes.any).isRequired,
  handleAddNewUser: PropTypes.func.isRequired,
};
